import { STRUCTURE_DIMENSIONS_PATH } from "./constants/dimensions.mjs";
import getCodeLists from "./getCodeLists.mjs";
const getDimensions = getCodeLists(STRUCTURE_DIMENSIONS_PATH);
export {
  getDimensions as default
};
